import React from "react";
import Chart from "react-apexcharts";
import { useChartTheme } from "../../../hooks/useChartTheme";
import { TrendOverYearType } from "../../../types/TeacherEvaluation";

const TrendOverYearsChart = ({ data }: { data: TrendOverYearType[] }) => {
  const { withTheme } = useChartTheme();
  const chartData = {
    series: [
      {
        name: "Média das Classificações",
        data: data.map((item) => item.averageClassification),
      },
    ],
    options: {
      chart: { type: "line" as const }, // Especifica explicitamente o tipo como "line"
      xaxis: { categories: data.map((item) => item.year) },
      title: { text: "Tendência ao Longo dos Anos" },
    },
  };

  return <Chart options={withTheme(chartData.options)} series={chartData.series} type="line" height={350} />;
};

export default TrendOverYearsChart;
